import axios from "axios";
let apiUrl = localStorage.getItem("apiUrl");
const apiUrlFromEnv = import.meta.env.VITE_API_URL;

if (import.meta.env.VITE_USER) {
  apiUrl = apiUrlFromEnv;
}
const fetchApiUrl = async () => {
  try {
    const axiosInstanceNew = axios.create({
      baseURL: "",
    });
    const response = await axiosInstanceNew.get("/api/url");
    if (response.data.url) {
      apiUrl = response.data.url;
    } else {
      apiUrl = apiUrlFromEnv;
    }
  } catch (error) {
    console.error("Error fetching api url:", error);
  }
};
if (apiUrl === null || apiUrl === "") {
  /*fetchApiUrl();
  let count = 0;
  //wait for the fetchApiUrl to complete
  const waitForApiUrl = () => {
    while ((apiUrl === null || apiUrl === '') && count < 5) {
      count++;
      new Promise(resolve => setTimeout(resolve, 100)); // Wait for 100ms before checking again
    }
  }
  waitForApiUrl();*/
}

const gisUrl = import.meta.env.VITE_GIS_API_URL;
// Create an instance of axios
const axiosInstance = axios.create({
  baseURL: apiUrl ? apiUrl : "", // Replace with your API base URL
  withCredentials: true,
});

export const axiosInstanceGis = axios.create({
  baseURL: "",
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Modify the config to include your custom header
    //config.headers['ssooblixuser'] = 'ramya.kathirvel';

    // When running locally, use VITE_USER to simulate the SSO user (replaces ModHeader)
    const localUser = import.meta.env.VITE_USER;
    if (localUser) {
      config.headers["ssooblixuser"] = localUser;
    }
    return config;
  },
  (error) => {
    // Handle the error
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => {
    // Handle the response data (success scenario)
    return response; // Return the response for further processing
  },
  async (error) => {
    const originalRequest = error.config;
    if (originalRequest.retry) {
      return Promise.reject(error);
    }
    try {
      const authResponse = await axiosInstance.get("/rest/user/authenticate");
      if (authResponse.data === "Success") {
        if (!(originalRequest?.url || "").includes("admin/")) {
          originalRequest.retry = true;
          return axiosInstance(originalRequest);
        } else {
          return Promise.reject(error);
        }
      } else {
        if (window.location.hostname !== "localhost") {
          window.location.href = authResponse.data;
        }
        return Promise.reject(error);
      }
    } catch (authError) {
      return Promise.reject(authError);
    }
  },
);

export default axiosInstance;
